import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { Layout } from '~/components/UI';
import { EmailsLogs } from '~/_domains/emailsLogs';
import { loadEmailsLogs } from '~/_domains/emailsLogs/actions';
import { DocumentDetailsDrawer } from '~/containers/Documents/Drawers/DocumentDetailsDrawer';

export const ScreensEmailsLogs = () => {
  const dispatch = useDispatch();
  const [selectedDocument, setSelectedDocument] = useState(null);

  // data is loading by default on AppContext
  return (
    <div>
      {/* <LoadingTopBar isActive={isLoading} /> */}
      <Layout>
        <EmailsLogs 
          refresh={() => dispatch(
            loadEmailsLogs({
              showLoading: false,
            }))} 
          setSelectedDocument={setSelectedDocument}
        />
        <DocumentDetailsDrawer
          isOpen={selectedDocument !== null}
          documentId={selectedDocument}
          closeModal={() => setSelectedDocument(null)}
        />
      </Layout>
    </div>
  );
};
